import { getConfig } from '@edx/frontend-platform';
import { getAuthenticatedHttpClient, getHttpClient } from '@edx/frontend-platform/auth';
import * as QueryString from 'query-string';

export async function registerRequest(registrationInformation) {
  const requestConfig = {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    isPublic: true,
  };

  const { data } = await getAuthenticatedHttpClient()
    .post(
      `${getConfig().LMS_BASE_URL}/api/user/v2/account/registration/`,
      QueryString.stringify(registrationInformation),
      requestConfig,
    )
    .catch((e) => {
      throw (e);
    });

  // Persist newsletter preference as part of registration flow (before UI redirect).
  // This avoids losing the request when redirect happens immediately after success.
  if (data?.success && Object.prototype.hasOwnProperty.call(registrationInformation, 'newsletter_subscribed')) {
    const newsletterSubscribed = Boolean(registrationInformation.newsletter_subscribed);
    try {
      await updateNewsletterSubscription(newsletterSubscribed);
    } catch (err) {
      // Best-effort fallback: for positive opt-in try public email subscription endpoint.
      if (newsletterSubscribed) {
        try {
          await subscribeNewsletterByEmail(registrationInformation.email);
        } catch (fallbackErr) {
          // Ignore newsletter side-effect failures to avoid blocking account creation.
        }
      }
    }
  }

  return {
    redirectUrl: data.redirect_url || `${getConfig().LMS_BASE_URL}/dashboard`,
    success: data.success || false,
    authenticatedUser: data.authenticated_user,
  };
}

export async function getFieldsValidations(formPayload) {
  const requestConfig = {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  };

  const { data } = await getHttpClient()
    .post(
      `${getConfig().LMS_BASE_URL}/api/user/v1/validation/registration`,
      QueryString.stringify(formPayload),
      requestConfig,
    )
    .catch((e) => {
      throw (e);
    });

  return {
    fieldValidations: data,
  };
}

export async function updateNewsletterSubscription(isSubscribed) {
  const requestConfig = {
    headers: { 'Content-Type': 'application/json' },
    isPublic: false,
  };

  await getAuthenticatedHttpClient()
    .post(
      `${getConfig().LMS_BASE_URL}/profile/newsletter/`,
      { is_subscribed: Boolean(isSubscribed) },
      requestConfig,
    )
    .catch((e) => {
      throw (e);
    });
}

export async function subscribeNewsletterByEmail(email) {
  const normalizedEmail = (email || '').trim();
  if (!normalizedEmail) {
    return;
  }

  const requestConfig = {
    headers: { 'Content-Type': 'application/json' },
    isPublic: true,
  };

  await getHttpClient()
    .post(
      `${getConfig().LMS_BASE_URL}/newsletter/subscribe/`,
      { email: normalizedEmail },
      requestConfig,
    )
    .catch((e) => {
      throw (e);
    });
}
